<template>
    <b-modal ref="mdlNuovaAnagrafica" size="xl" :title="titoloModal" @hidden="onCloseModal" @ok="onClickOk" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <div>
            <b-card class="sa-card" header="Anagrafica" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <!-- <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Tipo:</label>
                        <b-form-select v-model="jsonData.codiceTipo" disabled :options="tipoAnagraficaOptions" :value="null" value-field="codiceTipo" text-field="descrizioneTipo"></b-form-select> -->
                    <!-- <b-form-input v-model="jsonData.nomeMedicoPresente" placeholder="Nome"></b-form-input> -->
                    <!-- </b-col> -->
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Codice:</label>
                        <b-form-input v-model="jsonData.codice" placeholder="Codice"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Nominativo:</label>
                        <b-form-input v-model="jsonData.nominativo" placeholder="Nominativo"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Città:</label>
                        <b-form-input v-model="jsonData.citta" placeholder="Città"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Indirizzo:</label>
                        <b-form-input v-model="jsonData.indirizzo" placeholder="Indirizzo"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice Fiscale:</label>
                        <b-form-input v-model="jsonData.codiceFiscale" placeholder="Codice Fiscale"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Partita I.V.A.:</label>
                        <b-form-input v-model="jsonData.partitaIva" placeholder="Partita I.V.A."></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Telefono:</label>
                        <b-form-input v-model="jsonData.telefono" placeholder="Telefono"></b-form-input>
                    </b-col>
                    <!-- <b-col v-if="attivaFattura" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Descrizione Fattura:</label>
                        <b-form-input v-model="jsonData.descrizioneUno" placeholder="Descrizione Fattura"></b-form-input>
                    </b-col>
                    <b-col v-if="attivaFattura" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note Fattura:</label>
                        <b-form-textarea v-model="jsonData.noteUno" placeholder="Note Fattura"></b-form-textarea>
                    </b-col>
                    <b-col v-if="attivaArchivio" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Descrizione Archivio:</label>
                        <b-form-input v-model="jsonData.descrizioneDue" placeholder="Descrizione Archivio"></b-form-input>
                    </b-col>
                    <b-col v-if="attivaArchivio" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Note Archivio:</label>
                        <b-form-textarea v-model="jsonData.noteDue" placeholder="Note Archivio"></b-form-textarea>
                    </b-col> -->
                </b-row>
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaNote" :key="listKey" :fields="fields" :current-page="1" :per-page="100000" sort-icon-left head-variant="light">
                    <template v-slot:cell(tipo)="{ item }">
                        <span class="sa-label-data" v-if="item.tipo === 'P'">PRINCIPALE</span>
                        <span class="sa-label-data" v-if="item.tipo === 'A'">ARCHIVIO</span>
                    </template>
                    <template v-slot:cell(descrizione)="{ item }">
                        <b-form-input v-model="item.descrizione" placeholder="Descrizione"></b-form-input>
                    </template>
                    <template v-slot:cell(note)="{ item }">
                        <b-form-textarea v-model="item.note" placeholder="Note" rows="2"></b-form-textarea>
                    </template>
                </b-table>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <b-form-checkbox v-if="!nuovo" v-model="jsonData.attivo" name="check-button" switch>
                            <label class="sa-label-data">Attivo</label>
                        </b-form-checkbox>
                    </b-col>
                </b-row>
            </b-card>
            <modal-error ref="cmpModalError"></modal-error>
        </div>
    </b-modal>
</template>

<script>
import ModalError from "../../../template/components/modal/components/ModalError.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import Vue from "vue";
// import DatePicker from "vue2-datepicker";
export default {
    components: { ModalError },
    mixins: [UtilityMixin],
    // components: { DatePicker },
    data() {
        return {
            isNew: true,
            isReadonly: false,
            isRequired: false,
            pathResource: "/anagrafica",
            pathResourceTipiAnagrafica: "/dizionariotipi",
            titoloModal: "",
            nuovo: true,
            listKey: 0,
            attivaFattura: false,
            attivaArchivio: false,
            tipoAnagraficaOptions: [],
            fields: [
                {
                    label: "Tipo",
                    key: "tipo",
                    thStyle: "width: 15rem",
                    sortable: true,
                },
                {
                    label: "Descrizione",
                    key: "descrizione",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
                {
                    label: "Note",
                    key: "note",
                    // thStyle: "width: 5rem",
                    sortable: true,
                },
            ],
            jsonData: { nominativo: null, codiceTipo: null, indirizzo: null, citta: null, telefono: null, partitaIva: null, codiceFiscale: null, attivo: true, listaNote: [] },
        };
    },
    methods: {
        openModal(item) {
            let me = this;
            me.$emit("beforloadData");
            me.impostaPermessi();
            // console.log(item);
            if (item.nominativo !== null) {
                me.titoloModal = "Modifica Anagrafica";
                me.loadData(item.id);
                me.nuovo = false;
            } else {
                me.titoloModal = "Aggiungi Anagrafica";
                me.nuovo = true;
                me.jsonData = item;
                me.checkNote();
            }
            // console.log(item);

            me.loadTipiAnagrafica();
            me.$refs.mdlNuovaAnagrafica.show();
            me.$emit("afterLoadData");
        },
        loadData(id) {
            let me = this;
            // me.$emit("beforloadData");
            let link = process.env.VUE_APP_PATH_API + this.pathResource + "/" + id;
            UtilityMixin.methods.restCallGet(link, null, me.ripristinaRigaSuccess, me.ripristinaRigaError);
            // me.$refs.mdlNuovaAnagrafica.show();
        },

        ripristinaRigaSuccess(response) {
            let me = this;
            me.jsonData = response.data.data;
            // me.$refs.mdlNuovaAnagrafica.show();
        },
        ripristinaRigaError(response) {
            console.log(response);
        },
        checkNote() {
            let me = this;
            let filtro = {};
            filtro.sezioneDizionario = "ANAGRAFICA";
            UtilityMixin.methods.loadDataResources(me.pathResource + "/note", filtro, me.checkNoteSuccess, me.checkNoteError);
        },
        checkNoteSuccess(response) {
            let me = this;
            me.jsonData.listaNote = response.data.data;
            me.listKey++;
        },
        checkNoteError(response) {
            console.log(response);
        },
        impostaPermessi() {
            let me = this;
            me.attivaFattura = false;
            me.attivaArchivio = false;
            me.attivaFattura = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "articolifattura", 1);
            me.attivaArchivio = UtilityMixin.methods.verificaPermessi(Vue.prototype.user, "articoliarchivio", 1);
        },
        loadTipiAnagrafica() {
            let me = this;
            let filtro = {};
            filtro.sezioneDizionario = "ANAGRAFICA";
            UtilityMixin.methods.loadDataResources(me.pathResourceTipiAnagrafica, filtro, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.tipoAnagraficaOptions = response.data.data.list;
            me.tipoAnagraficaOptions.unshift({ codiceTipo: null, descrizioneTipo: "-Seleziona Valore-" });
        },
        loadDataError(response) {
            console.log(response);
        },
        onCloseModal() {
            let me = this;
            me.$emit("beforloadData");
            me.jsonData = { nominativo: null, codiceTipo: null, indirizzo: null, citta: null, telefono: null, partitaIva: null, codiceFiscale: null, attivo: true };
            me.$emit("afterLoadData");
        },
        onClickOk(bvModalEvent) {
            let me = this;
            me.$emit("beforloadData");
            bvModalEvent.preventDefault();
            // console.log(me.jsonData);
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonData, this.saveSuccessResponse, this.saveErrorResponse);
        },
        saveSuccessResponse(response) {
            let me = this;
            me.$emit("afterSaveSuccess", response);
            me.$emit("afterLoadData");
            me.$refs.mdlNuovaAnagrafica.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },

        saveErrorResponse(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
            this.$emit("afterLoadData");
        },
    },
};
</script>
